<template>
  <div class="mx-auto flex max-w-xl grow px-4">
    <div class="mt-8 flex flex-col space-y-6 md:mt-16">
      <h1 class="text-grays-darkest text-[32px] font-semibold">Contact Us</h1>
      <div class="space-y-2">
        <h2 class="text-xl font-semibold">
          Have Questions or Need Assistance?
        </h2>
        <p class="text-grays-darkest">
          We’re here to help! Whether you have questions about your order,
          glasses, or any other inquiries, feel free to reach out to us.
        </p>
      </div>
      <ContactCard />
    </div>
  </div>
</template>

<script setup lang="ts"></script>
